import script from "./GoToCrif.vue?vue&type=script&setup=true&lang=js"
export * from "./GoToCrif.vue?vue&type=script&setup=true&lang=js"

import "./GoToCrif.vue?vue&type=style&index=0&id=0217ec67&scoped=true&lang=css"

import exportComponent from "/var/www/Vakifbank-Vue-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0217ec67"]])

export default __exports__